import { Box } from '@mui/material'
import { Container } from '@mui/system'
import JobStepper from './JobStepper'
import { useEffect } from 'react'
import useAuth from '../../../hooks/use-auth'
import { ROLE } from '../../../constants'
import { useNavigate, useParams } from 'react-router-dom'

const Createjob = () => {
	const { user } = useAuth();
	const navigate = useNavigate();
	const { draftId } = useParams()

	useEffect(() => {
		if (user?.role_id && user.role_id !== ROLE.client) {
			navigate('/jobs/')
		}
	}, [user])

	return (
		<Box flex={5}>
			<Box sx={{ mt: 3 }}>
				<Container maxWidth="xl">
					<JobStepper draftId={draftId} />
				</Container>
			</Box>
		</Box>
	)
}

export default Createjob